// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cashFT_card__title[data-v-695fbf62]{width:100%;text-align:center;color:#1c2734;font-size:20px;font-style:normal;font-weight:600;line-height:normal}.cashFT_card__subTitle[data-v-695fbf62]{color:#1c2734;text-align:center;font-size:16px;font-style:normal;font-weight:400;line-height:140%;margin-top:32px;word-break:normal}.cashFT_card__img[data-v-695fbf62]{margin-top:32px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
